var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("app-resumo-cadastrante-areas-patrimoniais", {
                attrs: {
                  cadastrante: _vm.cadastro.cadastrante,
                  idCadastro: _vm.idCadastro
                }
              }),
              _c("app-divider", { attrs: { label: "Interessado" } }),
              _c("div", { staticClass: "pad5" }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("CNPJ:")]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.cadastro.interessado.pessoa.pessoaJuridica.cnpj
                        )
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.labelsCadastro.interessado.prefeitura))
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.cadastro.interessado.pessoa.pessoaJuridica
                            .razaoSocial
                        )
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.labelsCadastro.interessado.cpfPrefeito))
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.cadastro.interessado.prefeito.pessoaFisica.cpf
                        )
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.labelsCadastro.interessado.nomePrefeito))
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.cadastro.interessado.prefeito.pessoaFisica.nome
                        )
                    )
                  ])
                ]),
                _c(
                  "p",
                  [
                    _c("app-resumo-endereco", {
                      attrs: {
                        endereco: _vm.cadastro.interessado.pessoa.endereco
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "p",
                  [
                    _c("app-resumo-documentos", {
                      attrs: {
                        documentos: _vm.cadastro.interessado.documentos,
                        idCadastro: _vm.idCadastro,
                        codigoCadastro: "interessado"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("app-resumo-geo", {
                staticClass: "pad5",
                attrs: {
                  geo: _vm.cadastro.georreferenciamento,
                  idCadastro: _vm.idCadastro
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31d26e1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31d26e1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/areasPatrimoniais/components/Resumo.vue
// module id = null
// module chunks = 